module.exports = __webpack_public_path__ + "static/media/advantages-right.a0b6ec3c.png";